<template>
  <header class="site-header">
      <nav></nav>
      <nav class="site-nav">
          <router-link to="/" class="site-logo">
              <img src="../assets/mh_small_bg_64.png" alt="Mediocre Hobbies">
          </router-link>
          <router-link to="/" class="nav-link" exact-active-class="active">Home</router-link>
          <router-link to="/videos" class="nav-link" active-class="active">Videos</router-link>
          <!-- <router-link to="/stream" class="nav-link" active-class="active">Stream</router-link> -->
          <router-link to="/merch" class="nav-link" active-class="active">Merch</router-link>
          <router-link to="/affiliates" class="nav-link" active-class="active">Affiliates</router-link>
          <!-- <router-link to="/campaigns" class="nav-link" active-class="active">Campaign</router-link> -->
      </nav>

      <nav class="social-nav">
          <a href="https://www.instagram.com/mediocre_hobbies/" target="_blank" class="social-link"><svg fill="currentColor"><use xlink:href="../assets/social-icons.svg#instagram"></use></svg></a>
          <a href="https://twitter.com/MediocreHobbies" target="_blank" class="social-link"><svg fill="currentColor"><use xlink:href="../assets/social-icons.svg#twitter"></use></svg></a>
          <a href="https://www.facebook.com/MediocreHobbies/" target="_blank" class="social-link"><svg fill="currentColor"><use xlink:href="../assets/social-icons.svg#facebook"></use></svg></a>
          <a href="https://www.patreon.com/mediocrehobbies/" target="_blank" class="nav-link"><svg fill="currentColor"><use xlink:href="../assets/social-icons.svg#patreon"></use></svg></a>
      </nav>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SiteHeader',
});
</script>
